import { Component } from '@angular/core';

@Component({
  selector: 'default-digital',
  templateUrl: './digital.component.html',
  styleUrls: []
})
export class DigitalComponent {
}
